import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["text"]

    connect() {
        const stored = localStorage.getItem('theme')
        if (stored) {
            this.applyTheme(stored)
        } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            this.applyTheme('dark')
        } else {
            this.applyTheme('light')
        }
        this.updateText()
    }

    toggle(event) {
        if (event) event.preventDefault()
        const current = document.documentElement.getAttribute('data-theme')
        const next = current === 'light' ? 'dark' : 'light'
        this.applyTheme(next)
        localStorage.setItem('theme', next)
        this.updateText()
    }

    applyTheme(theme) {
        document.documentElement.setAttribute('data-theme', theme)
        document.body.setAttribute('data-theme', theme)
        document.documentElement.classList.toggle('dark', theme === 'dark')
    }

    updateText() {
        if (!this.hasTextTarget) return
        const theme = document.documentElement.getAttribute('data-theme')
        this.textTarget.textContent = theme === 'light' ? 'Light Mode' : 'Dark Mode'
    }
}
